import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import { Suspense } from "react";
import { useAuthStore } from "./features/auth/auth-store";
import { restoreConsent } from "./lib/consent";
import App from "./App.tsx";
import "./index.css";
import "./i18n";

// Restore cookie consent choice before GA fires any events
restoreConsent();

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? "production",
    release: import.meta.env.VITE_SENTRY_RELEASE,
  });
}

// Restore Sentry user from persisted auth
const persistedUser = useAuthStore.getState().user;
if (persistedUser) {
  Sentry.setUser({ id: persistedUser.id, username: persistedUser.username, email: persistedUser.email });
}

createRoot(document.getElementById("root")!).render(
  <Suspense fallback={<div>Loading...</div>}>
    <App />
  </Suspense>
);
